import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      authenticationToken: null,
    },
    getters: {
      authenticated: state => !!state.authenticationToken,
    },
    actions: {
      async login({ commit, dispatch, }, { username, password, }) {
        commit('setError', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const { jwt, } = await app.service('authentication').create({ username, password, });
          commit('setAuthenticationToken', jwt);
          dispatch('listConstants');
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
        } finally {
          commit('removePendingAction', actionId);
        }
      },

      async logout({ commit, dispatch, }) {
        const actionId = await dispatch('addPendingAction');
        await app.service('authentication').remove(null).catch(e => {});
        commit('resetState');
        commit('removePendingAction', actionId);
      },
    },
    mutations: {
      setAuthenticationToken: (state, authenticationToken) => state.authenticationToken = authenticationToken,
    },
  };
}
